import * as React from "react";

interface IDelayedRevealProps {
  from: string;
  wait: number;
}

export function DelayedReveal({
  children,
  from,
  wait,
}: React.PropsWithChildren<IDelayedRevealProps>) {
  const [visible, setVisible] = React.useState(false);
  const creationDate = new Date(from).getTime();
  const timeToShow = creationDate + wait;

  React.useEffect(() => {
    if (timeToShow <= Date.now()) {
      setVisible(true);
    }

    let timeoutId: NodeJS.Timeout;

    if (timeToShow > Date.now()) {
      timeoutId = setTimeout(() => {
        setVisible(true);
      }, timeToShow - Date.now());
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [creationDate, timeToShow]);

  if (!visible) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return <>{children}</>;
}
